import { render, staticRenderFns } from "./header-edit.vue?vue&type=template&id=2f2264a9&scoped=true&"
import script from "./header-edit.vue?vue&type=script&lang=js&"
export * from "./header-edit.vue?vue&type=script&lang=js&"
import style0 from "./header-edit.vue?vue&type=style&index=0&id=2f2264a9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2264a9",
  null
  
)

export default component.exports